import React, { useEffect, useState } from 'react'
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex, Grid, GridItem } from '@chakra-ui/react'
import MyDiv from './attendanceDetail.style'
import { AttendanceDetailList, AttendanceProfile } from '../components'
import * as routesNames from '../../../constants/routes'
import { useLocation } from 'react-router-dom'
import { useFetch } from '../../../hooks/useFetch'
import { CustomToast } from '../../../components'
import { AttendanceSummary } from './modal'

const AttendanceDetail = () => {
    const location = useLocation();
    const employeeId: number = location.state?.employeeId;
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [attendanceData, setAttendanceData] = useState<AttendanceSummary | null>(null);
    const [dateRange, setDateRange] = useState<{ start: Date, end: Date } | null>(null);
    const [appliedFilter, setAppliedFilter] = useState<Record<string, number[]>>({});

    const handleFilterApply = (filters: Record<string, number[]>) => {
        setAppliedFilter(filters);
    };


    const LoadAttendanceData = async () => {
        try {
            const params = new URLSearchParams({
                employeeId: employeeId ? employeeId.toString() : "",
                ...(dateRange ? { startDate: formatDate(dateRange.start) } : {}),
                ...(dateRange ? { endDate: formatDate(dateRange.end) } : {}),
                filters: JSON.stringify(appliedFilter)
            });

            const response = await fetchApi(`Hrlense_Attendance/GetEmployeeMonthlyAttendanceByEmployee?${params}`, "GET");
            if (response) {
                if (response.records.length === 0) {
                    addToast({ message: "No attendance data found for the selected month.", status: "warning", });
                }
                setAttendanceData(response);
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    useEffect(() => {
        if (employeeId) {
            LoadAttendanceData();
        }
    }, [dateRange, employeeId, appliedFilter]);

    const handleDateRangeChange = (dateRange: { start: Date, end: Date } | null) => {
        setDateRange(dateRange);
    }

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    return (
        <MyDiv>
            <Box>
                <Flex className="flex_header" >
                    <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
                        <BreadcrumbItem>
                            <BreadcrumbLink className="font_poppins text_md text_medium" color="gray.500" href={routesNames.ATTENDANCESHEET}>Attendance</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink className="font_poppins text_md text_medium" href="#">Employee Attendance</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Flex>
                <Grid className='grid_container'>
                    <GridItem colSpan={12}>
                        <Box mt={4} ml={4}>
                            <AttendanceProfile employeeId={employeeId} attendanceData={attendanceData} onDateRangeChange={handleDateRangeChange} onFilterApply={handleFilterApply}
                            />
                        </Box>
                    </GridItem>
                    <GridItem colSpan={12} pl={4} >
                        <AttendanceDetailList attendanceData={attendanceData} />
                    </GridItem>
                </Grid>

            </Box>
        </MyDiv>
    )
}

export default AttendanceDetail;
